<h2 mat-dialog-title class="dlg-title">
  Annuler une quantité vendue
  @if (sale) {<span class="dlg-sub">{{ name }} · ligne {{ sale.seq }}</span>}
</h2>
<mat-dialog-content class="dlg-body">
  @if (store.view && sale) {
    <dl class="figures">
      @for (f of figures; track f.label) {
        <div class="fig"><dt>{{ f.label }}</dt><dd class="num">{{ f.value }}</dd></div>
      }
    </dl>
    @if (sale.anomaly) {
      <span class="warn">{{ sale.anomaly }}</span>
    }
    @if (blocked) {
      <div class="blocked">{{ blocked }}</div>
    } @else {
      <section class="dlg-row">
        <div class="field qty">
          <label for="sale-qty">Quantité annulée</label>
          <input id="sale-qty" type="number" step="0.01" min="0.01" [value]="qtyText" (input)="setQty($event)" placeholder="0,00" />
          <span class="help">{{ help }}</span>
        </div>
      </section>
      <section class="dlg-row">
        <div class="lbl">Motif</div>
        @if (reasons.length) {
          <div class="chips">
            @for (r of reasons; track r.id) {
              <button type="button" class="chip" [attr.aria-pressed]="reasonId === r.id" (click)="pickReason(r.id)">
                <span class="rdot" [style.background]="r.color ?? 'var(--ink-3)'"></span>{{ r.name }}
              </button>
            }
          </div>
        } @else if (store.reasonsState === 'loading') {
          <div class="loading"><mat-spinner diameter="16"></mat-spinner>Motifs en cours de chargement</div>
        } @else if (store.reasonsState === 'error') {
          <div class="hint reasons-error">Motifs illisibles (c_values 42). <button mat-stroked-button type="button" class="retry-reasons" (click)="store.ensureReasons()">Réessayer</button></div>
        } @else {
          <div class="hint">Aucun motif SALE_CANCELLATION actif dans c_values 42.</div>
        }
        <input class="comment" type="text" [value]="comment" (input)="setComment($any($event.target).value)"
          [placeholder]="commentRequired ? 'Commentaire (obligatoire)' : 'Commentaire (facultatif)'" aria-label="Commentaire" />
      </section>
    }
    <section class="dlg-row">
      <div class="lbl">Annulations de la ligne</div>
      @if (rows.length) {
        <ul class="hist">
          @for (r of rows; track r.id) {
            <li [class.cancelled]="!r.live">
              <div class="main">
                <span class="what">{{ r.what }}</span>
                <small>{{ r.stamp }}@if (r.replaces) { · remplace n° {{ r.replaces }}}</small>
                @if (r.cancelled) {<small>{{ r.cancelled }}</small>}
              </div>
              @if (r.live) {
                <div class="acts"><button mat-stroked-button color="warn" type="button" class="cancel-entry" (click)="cancel(r.id)">Annuler</button></div>
              }
            </li>
          }
        </ul>
      } @else {
        <div class="hint">Aucune annulation sur cette ligne.</div>
      }
    </section>
  } @else if (store.error) {
    <div class="blocked">{{ store.error }}</div>
  } @else if (store.view) {
    <div class="blocked">Ligne {{ data.lineId }} absente des ventes du dossier.</div>
  } @else {
    <div class="loading"><mat-spinner diameter="24"></mat-spinner>Chargement du dossier</div>
  }
</mat-dialog-content>
<div class="dlg-effect">
  <app-rental-effect [state]="sim" [rangeText]="effectText" [warnings]="[]" [errors]="errors" [scope]="null" [focusLineIds]="[]" [store]="store"></app-rental-effect>
</div>
<mat-dialog-actions class="dlg-actions">
  <span class="spacer"></span>
  <button mat-stroked-button type="button" class="close" (click)="close()" [disabled]="saving">Fermer</button>
  <button mat-flat-button color="primary" type="button" class="save" [disabled]="!canSave || saving" (click)="save()">Enregistrer</button>
</mat-dialog-actions>
